<div class="container-fluid">
	<div class="row align-items-end mx-0 my-3">
		<div class="col">
			<h4>Reglas de comisiones</h4>
		</div>
		<div class="col-auto">
			<button type="button" class="btn btn-secondary" (click)="newRule()">Nueva</button>
		</div>
	</div>

	<div class="row">
		<div class="col-12 col-xl-5 mb-3">
			<form ngNativeValidate (submit)="save()" class="card p-3">
				<h5 class="mb-3">{{selected_rule.id ? 'Editar regla' : 'Nueva regla'}}</h5>
				<div class="row">
					<div class="col-12 col-md-6 form-group">
						<label>Sucursal</label>
						<select name="store_id" [(ngModel)]="selected_rule.store_id" class="form-control" required>
							<option [ngValue]="null">Seleccionar</option>
							<option *ngFor="let store of store_list" [ngValue]="store.id">{{store.name}}</option>
						</select>
					</div>
					<div class="col-12 col-md-6 form-group">
						<label>Tipo de precio</label>
						<select name="price_type_id" [(ngModel)]="selected_rule.price_type_id" class="form-control" required>
							<option [ngValue]="null">Seleccionar</option>
							<option *ngFor="let price_type of price_type_list" [ngValue]="price_type.id">{{price_type.name}}</option>
						</select>
					</div>
					<div class="col-12 col-md-6 form-group">
						<label>Comisión base %</label>
						<input type="number" name="base_percent" [(ngModel)]="selected_rule.base_percent" class="form-control" min="0" step="any" required>
					</div>
					<div class="col-12 col-md-6 form-group">
						<label>Reducción por 1% descuento</label>
						<input type="number" name="discount_reduction_per_percent" [(ngModel)]="selected_rule.discount_reduction_per_percent" class="form-control" min="0" step="any" required>
					</div>
					<div class="col-12 col-md-6 form-group">
						<label>Estatus</label>
						<select name="status" [(ngModel)]="selected_rule.status" class="form-control" required>
							<option value="ACTIVE">Activa</option>
							<option value="DELETED">Inactiva</option>
						</select>
					</div>
				</div>
				<div class="text-end mt-3">
					<button type="submit" class="btn btn-primary" [disabled]="is_loading">Guardar</button>
				</div>
			</form>
		</div>

		<div class="col-12 col-xl-7">
			<div class="card p-3">
				<app-loading [is_loading]="is_loading"></app-loading>
				<div class="table-responsive">
					<table class="table table-sm table-nowrap mb-0">
						<thead>
							<tr>
								<th>Sucursal</th>
								<th>Tipo de precio</th>
								<th class="text-end">Base %</th>
								<th class="text-end">Reducción</th>
								<th>Estatus</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let rule of commission_rule_list" class="align-middle pointer" (click)="selectRule(rule)">
								<td>{{getStoreName(rule.store_id)}}</td>
								<td>{{getPriceTypeName(rule.price_type_id)}}</td>
								<td class="text-end">{{rule.base_percent | number:'1.2-6'}}</td>
								<td class="text-end">{{rule.discount_reduction_per_percent | number:'1.2-6'}}</td>
								<td>{{rule.status == 'ACTIVE' ? 'Activa' : 'Inactiva'}}</td>
							</tr>
							<tr *ngIf="commission_rule_list.length == 0 && !is_loading">
								<td colspan="5">
									<div class="alert alert-light m-3">No se encontraron reglas</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
